import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-result-not-found',
  templateUrl: './result-not-found.component.html',
  styleUrls: ['./result-not-found.component.css']
})
export class ResultNotFoundComponent implements OnInit {

  @Input() inputNotFound :NotFound;
  constructor() { }

  ngOnInit(): void {

  }

  //inface
}
  
  interface NotFound{
    visible: boolean,
    message:string;

  }


